import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';

// #region -------------- Interfaces -------------------------------------------------------------------

interface IProps extends RouteComponentProps { }

// #endregion

// #region -------------- Component -------------------------------------------------------------------

class ScrollToTop extends React.PureComponent<IProps> {

  public componentDidUpdate(prevProps: IProps) {
    const { location } = this.props;
    const { location: prevLocation } = prevProps;

    const pathname = location && location.pathname;
    const prevPathname = prevLocation && prevLocation.pathname;

    if (pathname !== prevPathname) {
      window.scrollTo(0, 0);
    }
  }

  public render() {
    return this.props.children;
  }
}

// #endregion

export const ScrollToTopWithRouter = withRouter(ScrollToTop);
